/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ModalExtratoUtilizacaoAliases {
  BUTTON_GERAR = 'button-gerar',
  DATE_FIELD_0 = 'date-field-0',
  DATE_FIELD_1 = 'date-field-1',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_2 = 'field-2',
  FORM = 'form',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  PANEL_EXTRATO_UTILIZACAO = 'panel-extrato-utilizacao',
  TEXT_0 = 'text-0',
}
export { ModalExtratoUtilizacaoAliases };
